module.exports = __webpack_public_path__ + "static/img/1.abe7d9f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/new/1.jpg
// module id = s3Wp
// module chunks = 0